import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ffd73f78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collapse-title" }
const _hoisted_2 = { class: "collapse-title" }
const _hoisted_3 = { class: "collapse-title" }
const _hoisted_4 = { class: "collapse-title" }
const _hoisted_5 = { class: "collapse-title" }
const _hoisted_6 = { class: "collapse-title" }
const _hoisted_7 = {
  key: 0,
  class: "action-bar"
}

import { computed, onMounted, PropType, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import Anchor from '@/components/anchor/anchor.vue'
import BasicOptions from '@/views/dashboard/_components/group-policy-settings/_components/basic-settings/_components/basic-options/basic-options.vue'
import NotifySettings from '@/views/dashboard/_components/group-policy-settings/_components/basic-settings/_components/notify-settings/notify-settings.vue'
import UpgradeSettings from '@/views/dashboard/_components/group-policy-settings/_components/basic-settings/_components/upgrade-settings/upgrade-settings.vue'
import ContextMenuSettings from '@/views/dashboard/_components/group-policy-settings/_components/basic-settings/_components/context-menu-settings/context-menu-settings.vue'
import PopupBlock from '@/views/dashboard/_components/group-policy-settings/_components/basic-settings/_components/popup-block/popup-block.vue'
import Toolbox from '@/views/dashboard/_components/group-policy-settings/_components/basic-settings/_components/toolbox/toolbox.vue'
import {
  GroupPolicySettingsService,
  GroupPolicyTypes,
  BasicSettingsStrategy
} from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { OperateType } from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.service'
import type { AnchorItem } from '@/components/anchor/types'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'basic-settings',
  props: {
  operateType: {
    type: String as PropType<'edit' | 'add' | 'read'>,
    default: 'edit'
  },
  policyId: {
    type: String,
    default: undefined
  },
  activeName: {
    type: String,
    default: ''
  }
},
  emits: ['cancel', 'save'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const DEFAULT_STRATEGY: BasicSettingsStrategy = {
  basic: {
    cloud_security: 0,
    auto_interrupt: 0,
    security_msg_center: 0,
    pop_location: 0,
    allow_notify_hackattack: 0,
    allow_notify_spreadinfo: 0,
    allow_notify_wormattack: 0,
    allow_notify_leak: 0,
    auto_upgrade: 0,
    upgrade_notify: 0,
    clean_upgrade_trash: 0,
    rightmenu_addscan: 1,
    rightmenu_addcrush: 0,
    rightmenu_sysslim_menu: 1,
    rightmenu_accfavorite: 0,
    rightmenu_largecleanup_menu: 1,
    soft_purifier_switch: 0,
    tool_switch: 0,
    proxy: {
      method: 0,
      mode: 0,
      require_auth: 0
    }
  }
}

const props = __props

const emits = __emit

const injector = useReflectiveInjector()
const service = injector.get(GroupPolicySettingsService)

const loading = ref(true)
const hasEdit = ref(false)
const activeSection = ref('#section-basic-options')
const activeNames = ref(
  IS_JP_ONLY_BUILD
    ? ['basic-options', 'notify-settings', 'upgrade-settings', 'context-menu-settings']
    : ['basic-options', 'notify-settings', 'upgrade-settings', 'context-menu-settings', 'popup-block', 'toolbox']
)
const anchorRef = ref<InstanceType<typeof Anchor> | null>(null)
const contentRef = ref<HTMLElement | null>(null)

const strategy = reactive<BasicSettingsStrategy>(JSON.parse(JSON.stringify(DEFAULT_STRATEGY)))

const anchorItems = computed<AnchorItem[]>(() => {
  void locale.value
  const items: AnchorItem[] = [
    { title: t('groupPolicySettings.basicOptionsTitle'), href: '#section-basic-options' },
    { title: t('groupPolicySettings.remindSettingsTitle'), href: '#section-notify-settings' },
    { title: t('groupPolicySettings.upgradeSettingsCollapseTitle'), href: '#section-upgrade-settings' },
    { title: t('groupPolicySettings.contextMenuCollapseTitle'), href: '#section-context-menu-settings' },
  ]
  if (!IS_JP_ONLY_BUILD) {
    items.push(
      { title: t('groupPolicySettings.popupBlockCollapseTitle'), href: '#section-popup-block' },
      { title: t('groupPolicySettings.toolboxCollapseTitle'), href: '#section-toolbox' }
    )
  }
  return items
})

function getSettings() {
  loading.value = true
  service.getSettings({
    id: props.policyId,
    type: GroupPolicyTypes.BasicSettings
  }).then(response => {
    Object.assign(strategy, response.strategy || {})
  }).finally(() => {
    loading.value = false
  })
}

function saveSettings() {
  service.saveSettings({
    id: props.policyId,
    type: GroupPolicyTypes.BasicSettings,
    strategy: JSON.stringify(strategy)
  }).then(() => {
    service.updateEditTab(false)
    hasEdit.value = false
    emits('save', 'basic-settings')
  })
}

function handleChange() {
  hasEdit.value = true
  service.updateEditTab(true)
}

function handleSave() {
  saveSettings()
}

function handleCancel() {
  emits('cancel')
}

service.hasEditTab.subscribe((val: boolean) => {
  hasEdit.value = val
})

service.saveTab.subscribe((name: string) => {
  if (name === 'basic-settings') {
    saveSettings()
  }
})

watch(() => props.activeName, (newVal) => {
  if (newVal === 'basic-settings') {
    getSettings()
  }
})

onMounted(() => {
  getSettings()
})

return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(ContentAdaptLayout, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["tab-container", { readonly: __props.operateType === _unref(OperateType).read }])
      }, [
        _createVNode(Anchor, {
          ref_key: "anchorRef",
          ref: anchorRef,
          modelValue: activeSection.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSection).value = $event)),
          items: anchorItems.value,
          offset: 10,
          container: contentRef.value,
          class: "settings-anchor"
        }, null, 8, ["modelValue", "items", "container"]),
        _createElementVNode("div", {
          ref_key: "contentRef",
          ref: contentRef,
          class: "settings-content"
        }, [
          _createVNode(_component_el_collapse, {
            modelValue: activeNames.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((activeNames).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                name: "basic-options",
                class: "el-card",
                id: "section-basic-options"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('groupPolicySettings.basicOptionsTitle')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(BasicOptions, {
                    modelValue: strategy.basic,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.basic) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                name: "notify-settings",
                class: "el-card",
                id: "section-notify-settings"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('groupPolicySettings.remindSettingsTitle')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(NotifySettings, {
                    modelValue: strategy.basic,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.basic) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                name: "upgrade-settings",
                class: "el-card",
                id: "section-upgrade-settings"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.upgradeSettingsCollapseTitle')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(UpgradeSettings, {
                    modelValue: strategy.basic,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.basic) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                name: "context-menu-settings",
                class: "el-card",
                id: "section-context-menu-settings"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('groupPolicySettings.contextMenuCollapseTitle')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(ContextMenuSettings, {
                    modelValue: strategy.basic,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((strategy.basic) = $event)),
                    readonly: __props.operateType === _unref(OperateType).read,
                    onChange: handleChange
                  }, null, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }),
              (!_unref(IS_JP_ONLY_BUILD))
                ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                    key: 0,
                    name: "popup-block",
                    class: "el-card",
                    id: "section-popup-block"
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('groupPolicySettings.popupBlockCollapseTitle')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(PopupBlock, {
                        modelValue: strategy.basic,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((strategy.basic) = $event)),
                        readonly: __props.operateType === _unref(OperateType).read,
                        onChange: handleChange
                      }, null, 8, ["modelValue", "readonly"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(IS_JP_ONLY_BUILD))
                ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                    key: 1,
                    name: "toolbox",
                    class: "el-card",
                    id: "section-toolbox"
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('groupPolicySettings.toolboxCollapseTitle')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(Toolbox, {
                        modelValue: strategy.basic,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((strategy.basic) = $event)),
                        readonly: __props.operateType === _unref(OperateType).read,
                        onChange: handleChange
                      }, null, 8, ["modelValue", "readonly"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 512)
      ], 2),
      (__props.operateType !== _unref(OperateType).read)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: handleSave,
              disabled: !hasEdit.value && __props.operateType !== _unref(OperateType).add && 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: handleCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})